import React from "react";
import { Grid, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import "../../../App.css";

const BookingsCard = ({ title, name, clickHandler, index }) => {
  return (
    <Grid
      container
      style={{
        borderBottom: "1px solid #EEEBEF",
        marginTop: "20px",
        paddingBottom: "20px",
        cursor: "pointer",
      }}
      onClick={() => clickHandler(index)}
    >
      <Grid item sm={2} style={{ display: "flex", justifyContent: "center" }}>
        <AccountCircleIcon
          style={{ height: "60px", width: "60px", color: "#EEEBEF" }}
        />
      </Grid>
      <Grid item sm={9}>
        <Typography style={{ fontWeight: "bold" }}>{title}</Typography>
        <Typography className="ammanat-darker-gray">{name}</Typography>
      </Grid>
      <Grid item sm={1}>
        <div
          className="icon-button"
          style={{
            cursor: "pointer",
            border: "1px solid rgba(238, 235, 239, 1)",
            color: "rgba(165, 164, 170, 1)",
          }}
          //   onClick={chatButtonHandler}
        >
          <ChatOutlinedIcon />
        </div>
      </Grid>
    </Grid>
  );
};

export default BookingsCard;
